import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminCustomers() {
    const [items, setItems] = useState([]);
    const [subs, setSubs] = useState([]);

    useEffect(() => {
        api.get("/admin/customers").then(r => setItems(r.data));
        api.get("/admin/newsletter").then(r => setSubs(r.data));
    }, []);

    return (
        <div data-testid="admin-customers">
            <div className="overline mb-2">CRM</div>
            <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)] mb-10">Clienti</h1>

            <div className="grid lg:grid-cols-2 gap-8">
                <div>
                    <h2 className="font-display text-2xl text-[color:var(--ms-charcoal)] mb-4">Account registrati ({items.length})</h2>
                    {items.length === 0 ? (
                        <div className="panel p-10 text-center text-[color:var(--ms-muted)] text-sm">Nessun cliente ancora.</div>
                    ) : (
                        <div className="panel divide-y divide-[color:var(--ms-border)]">
                            {items.map(c => (
                                <div key={c.id} className="px-4 py-3 text-sm flex justify-between items-center" data-testid={`customer-row-${c.id}`}>
                                    <div>
                                        <div className="text-[color:var(--ms-charcoal)]">{c.name}</div>
                                        <div className="text-[color:var(--ms-muted)] text-xs">{c.email}</div>
                                    </div>
                                    <div className="text-[color:var(--ms-muted)] text-xs">{new Date(c.created_at).toLocaleDateString("it-IT")}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div>
                    <h2 className="font-display text-2xl text-[color:var(--ms-charcoal)] mb-4">Newsletter ({subs.length})</h2>
                    {subs.length === 0 ? (
                        <div className="panel p-10 text-center text-[color:var(--ms-muted)] text-sm">Nessun iscritto ancora.</div>
                    ) : (
                        <div className="panel divide-y divide-[color:var(--ms-border)]">
                            {subs.map(s => (
                                <div key={s.id} className="px-4 py-3 text-sm flex justify-between" data-testid={`sub-row-${s.id}`}>
                                    <span>{s.email}</span>
                                    <span className="text-[color:var(--ms-muted)] text-xs">{new Date(s.created_at).toLocaleDateString("it-IT")}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
